"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metricsDidReceiveHandler = metricsDidReceiveHandler;
var _featureFlags = require("@studio/feature.flags/featureFlags");
var _updateNetworkHealth = require("../systemHealth/updateNetworkHealth");
var _ChimeMetricsProcessor = require("../ChimeMetricsProcessor");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var previousCandidatePairId = null;
var logger = new _StudioLogger.StudioLogger('chime-observers-metricsDidReceiveHandler');
function logIceCandidatePair(stats, candidatePairId) {
  stats.forEach(function (report) {
    if (report.id === candidatePairId) {
      var localCandidate = stats.get(report.localCandidateId);
      var remoteCandidate = stats.get(report.remoteCandidateId);
      logger.info('selected ICE candidates', {
        localCandidate: localCandidate,
        remoteCandidate: remoteCandidate,
        title: 'selected ICE candidates'
      });
    }
  });
}
function metricsDidReceiveHandler(dispatch, setAttendeeNetworkHealth, setAttendeeReceivedFrame, meetingSession, currentAttendeeId, payload, clientMetricReport) {
  var _meetingSession$confi;
  if ((0, _featureFlags.shouldHaveFeature)('studio.tempMeetingScorePOC')) {
    var chimeMetricsProcessor = new _ChimeMetricsProcessor.ChimeMetricsProcessor();
    chimeMetricsProcessor.process(clientMetricReport, currentAttendeeId, meetingSession);
  }
  var metricReport = clientMetricReport.getObservableMetrics();
  var videoMetricReport = clientMetricReport.getObservableVideoMetrics();
  var networkHealthIndicatorsEnabled = (0, _featureFlags.shouldHaveFeature)('studio.networkHealthIndicators');
  var networkHealthMonitoringStatsEnabled = (0, _featureFlags.shouldHaveFeature)('studio.networkHealthMonitoringStats');
  if (networkHealthIndicatorsEnabled || networkHealthMonitoringStatsEnabled) {
    (0, _updateNetworkHealth.updateNetworkHealth)(clientMetricReport, meetingSession, currentAttendeeId, dispatch, setAttendeeNetworkHealth, setAttendeeReceivedFrame);
  }
  var rtcStatsReport = clientMetricReport.getRTCStatsReport();

  /**
   * Create a map of codecs being used
   * It will be used below to fetch the code being used for current video stream
   */
  var codecMap = {};
  rtcStatsReport.forEach(function (report) {
    if (report.type === 'codec' && report.id && report.mimeType) {
      codecMap[report.id] = report.mimeType;
    }
    if (report.type === 'transport') {
      var candidatePairId = report.selectedCandidatePairId;
      if (candidatePairId !== previousCandidatePairId) {
        previousCandidatePairId = candidatePairId;
        logIceCandidatePair(rtcStatsReport, candidatePairId);
      }
    }
  });

  /**
   * Fetch current attendee video metrics from video metric report
   * We will use the active stream (ssrc) from RTC stats report to find
   * the stream index to use in video metric report
   */
  var currentAttendeeVideoMetrics = {};
  var receivedCodecs = new Set();
  var decoderImplementations = new Set();
  rtcStatsReport.forEach(function (report) {
    if (report.type === 'outbound-rtp' && report.kind === 'video' && report.active === true && report.packetsSent > 0) {
      currentAttendeeVideoMetrics = _objectSpread({}, videoMetricReport[currentAttendeeId][report.ssrc]);
      currentAttendeeVideoMetrics['scalabilityMode'] = report.scalabilityMode;
      if (report.codecId in codecMap) {
        currentAttendeeVideoMetrics['codec'] = codecMap[report.codecId];
      }
    }
    if (report.type === 'inbound-rtp' && report.kind === 'video' && report.codecId && report.decoderImplementation) {
      receivedCodecs.add(codecMap[report.codecId]);
      decoderImplementations.add(report.decoderImplementation);
    }
    if (report.type === 'media-source' && report.kind === 'video') {
      currentAttendeeVideoMetrics['mediaSourceWidth'] = report.width;
      currentAttendeeVideoMetrics['mediaSourceHeight'] = report.height;
      currentAttendeeVideoMetrics['mediaSourceFramesPerSecond'] = report.framesPerSecond;
    }
  });
  currentAttendeeVideoMetrics['receivedCodecs'] = Array.from(receivedCodecs);
  currentAttendeeVideoMetrics['decoderImplementations'] = Array.from(decoderImplementations);
  var uplinkPolicy = meetingSession === null || meetingSession === void 0 || (_meetingSession$confi = meetingSession.configuration) === null || _meetingSession$confi === void 0 ? void 0 : _meetingSession$confi.videoUplinkBandwidthPolicy;
  if (uplinkPolicy) {
    if ('getNumberOfPublishedVideoSources' in uplinkPolicy && typeof uplinkPolicy.getNumberOfPublishedVideoSources === 'function') {
      currentAttendeeVideoMetrics['numVideos'] = uplinkPolicy.getNumberOfPublishedVideoSources();
    }
    if ('getNumParticipants' in uplinkPolicy && typeof uplinkPolicy.getNumParticipants === 'function') {
      currentAttendeeVideoMetrics['numParticipants'] = uplinkPolicy.getNumParticipants();
    }
  }

  /**
   * Calculate videoDownstreamBitrate and videoPacketReceivedPerSecond
   * as sum of video bitrate and video packets received for all incoming video streams
   */
  var videoDownstreamBitrate = 0;
  var videoPacketReceivedPerSecond = 0;
  var videoTotalDecodeTime = 0;
  for (var attendeeId in videoMetricReport) {
    var videoStreams = Object.entries(videoMetricReport[attendeeId]);

    // This should not ideally happen. It's just a safeguard
    if (videoStreams.length === 0) {
      continue;
    }
    /**
     * There should never be multiple streams for a attendee. If this happens, this is a Chime SDK bug
     * One such bug was fixed in SDK 3.26.0 (https://github.com/aws/amazon-chime-sdk-js/blob/v3.26.0/CHANGELOG.md)
     * "Do not store metrics for video send stream that no longer exists after reconnection"
     * But we can't be sure. If there are multiple stream, it'll result in erroneous data
     * So we set videoDownstreamBitrate and videoPacketReceivedPerSecond to -1 to denote error and bail.
     */
    if (videoStreams.length > 1) {
      videoDownstreamBitrate = -1;
      videoPacketReceivedPerSecond = -1;
      break;
    } else {
      var _videoStreams$ = _slicedToArray(videoStreams[0], 2),
        streamId = _videoStreams$[0],
        streamData = _videoStreams$[1];
      if (streamData.videoDownstreamBitrate) {
        videoDownstreamBitrate += parseInt(streamData.videoDownstreamBitrate);
        videoTotalDecodeTime += clientMetricReport.averageTimeSpentPerSecondInMilliseconds('totalDecodeTime', streamId);
      }
      if (streamData.videoDownstreamPacketsReceived) {
        videoPacketReceivedPerSecond += parseInt(streamData.videoDownstreamPacketsReceived);
      }
    }
  }
  currentAttendeeVideoMetrics['videoDownstreamBitrate'] = videoDownstreamBitrate;
  currentAttendeeVideoMetrics['videoPacketReceivedPerSecond'] = videoPacketReceivedPerSecond;
  currentAttendeeVideoMetrics['videoDownstreamTotalDecodeTimePerSecond'] = videoTotalDecodeTime;
  payload.metrics = _objectSpread(_objectSpread({}, metricReport), currentAttendeeVideoMetrics);
}